<div class="login-container">
  <div class="login-left">
    <div class="login-form-container">
      <div class="sispac-logo-section">
        <div class="sispac-logo-container">
          <div class="sispac-logo-wrap">
            <img
              *ngIf="isChristmasMode"
              src="../../../assets/img/christmas/Gemini_Generated_Image_rcto20rcto20rcto-removebg-preview.png"
              alt="Logo Natal"
              class="logo-image">
            <img
              *ngIf="!isChristmasMode"
              src="../../../assets/img/sispac-new/logo-sispac-new.png"
              alt="SISPAC"
              class="logo-image">
          </div>
          <div class="sispac-title" *ngIf="!isChristmasMode">
            <img
              src="../../../assets/img/sispac-new/nome-sispac-new.png"
              alt="SISPAC"
              class="title-image">
          </div>
        </div>
        <!-- <p class="system-description">
          Sistema de Controle de Procedimentos Administrativos Correcionais - SISPAC
        </p> -->
      </div>

      <div class="form-header">
        <mat-icon class="warning-icon">view_module</mat-icon>
        <h2>Acesso aos módulos</h2>
      </div>

      <div class="inativacao-info">
        <mat-card class="info-card sem-modulos-highlight">
          <mat-card-content>
            <p class="info-message principal">Módulos não cadastrados para este usuário.</p>
            <p class="info-complemento">
              Você não possui permissão de acesso a nenhum módulo do sistema. Solicite a um
              <strong>administrador do servidor</strong> que cadastre ou ajuste seus vínculos de módulo e perfil.
            </p>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="action-options">
        <div class="option-card contact-option module-contact">
          <h3>Contatar administrador</h3>
          <p>Se você deveria ter acesso, peça ao administrador do sistema para conferir seu cadastro de módulos e perfis.</p>

          <button mat-stroked-button color="accent"
                  class="action-button full-width"
                  type="button"
                  (click)="contatarAdministrador()">
            <mat-icon>support_agent</mat-icon>
            Contatar suporte
          </button>
        </div>
      </div>

      <div class="back-to-login">
        <button mat-button
                class="back-button"
                type="button"
                (click)="voltarLogin()">
          <mat-icon>arrow_back</mat-icon>
          Voltar ao login
        </button>
      </div>
    </div>
  </div>

  <div class="login-right">
    <div class="welcome-content">
      <div class="welcome-header">
        <h1>Permissões<br>de acesso</h1>
      </div>

      <div class="welcome-description">
        <p>O acesso ao SISPAC é concedido por módulo, conforme sua lotação e atribuições.</p>
        <p>Sem módulos vinculados, não é possível prosseguir. O administrador pode incluir os módulos adequados ao seu perfil.</p>
      </div>

      <div class="security-info">
        <mat-icon>admin_panel_settings</mat-icon>
        <p>A gestão de acessos é feita pelo administrador do sistema para manter a conformidade com as políticas de segurança.</p>
      </div>

      <div class="institutional-branding">
        <img
          src="../../../assets/img/sispac-new/logo-cge-e-estado-goias.png"
          alt="Controladoria-Geral do Estado e Governo de Goiás"
          class="branding-logo">
        <div class="branding-info">
          <p>Controladoria-Geral do Estado de Goiás</p>
          <p>Desenvolvimento e Gestão</p>
        </div>
      </div>
    </div>
  </div>
</div>
